import { useEffect, useState } from 'react'
import { Button, Typography, FormLabel, Grid, Box, Paper, LinearProgress, CircularProgress } from '@mui/material'
import { Utils } from '../../utils'
import useAuth from '../../context/auth'
import { LoadingButton } from '@mui/lab'
import { ClientsService } from '../../services/clients'
import { useLocation, useNavigate } from 'react-router-dom'
import imageCompression from 'browser-image-compression'
import { del, get, set } from 'idb-keyval'

export function ManualPhotos() {
    const { handleModal } = useAuth()
    const navigate = useNavigate()
    const { state } = useLocation()
    const { getData } = useAuth()
    const [loading, setLoading] = useState(false)


    const [manualPhotosStep, setManualPhotosStep] = useState<number | null>(null)
    const [restoring, setRestoring] = useState(true)
    const [photos, setPhotos] = useState({
        serious: null as File | null,
        smiling: null as File | null,
        frontDoc: null as File | null,
        backDoc: null as File | null
    })

    const contentToRender = [
        { title: "FOTO DO ROSTO (NATURAL)", name: "face-serious", key: "serious", capture: "user" },
        { title: "FOTO DO ROSTO (SORRINDO)", name: "face-smiling", key: "smiling", capture: "user" },
        { title: "FOTO DO SEU DOCUMENTO (FRENTE)", name: "front-doc", key: "frontDoc", capture: "environment" },
        { title: "FOTO DO SEU DOCUMENTO (VERSO)", name: "back-doc", key: "backDoc", capture: "environment" }
    ]

    const totalSteps = contentToRender.length

    const handleFileChange = (key: string, file: File) => {
        setPhotos(prev => ({ ...prev, [key]: file }))
    }

    const handleNextStep = () => {
        const current = contentToRender[manualPhotosStep as number - 1]
        if (photos[current.key as keyof typeof photos]) {
            setManualPhotosStep(manualPhotosStep as number + 1)
        } else {
            handleModal(true, {
                message: `Selecione a ${current.title} antes de continuar`,
                type: "warning"
            })
        }
    }

    const sendPhotos = async () => {
        setLoading(true)
        const data = new FormData()

        for (let photo of contentToRender) {
            const file = photos[photo.key as keyof typeof photos]
            if (!file) continue;

            const options = {
                maxSizeMB: 2,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }

            try {
                const compressedFile = await imageCompression(file, options)

                data.append(photo.name, compressedFile, compressedFile.name)
            } catch (err) {
                console.error(`Erro ao comprimir ${photo.name}:`, err)
                handleModal(true, {
                    message: `Erro ao processar a imagem "${photo.title}"`,
                    type: "error"
                })
                setLoading(false)
                return
            }
        }

        ClientsService.uploadPhoto(data)
            .then(() => {
                navigate("/cliente/fotos-da-empresa", {
                    state
                })
                sessionStorage.removeItem("manualPhotosStep")
                del('manualPhotosData')
            })
            .catch((err) => handleModal(true, {
                message: "Erro no envio das fotos.",
                type: "error"
            }))
            .finally(() => {
                setLoading(false)
            })
    }

    const renderStep = () => {

        if (manualPhotosStep === null) {
            return (
                <Grid container justifyContent="center" alignItems={"center"} height={"calc(100vh - 13.5rem)"} className="container">
                    <CircularProgress />
                </Grid>
            )
        }

        if (manualPhotosStep === 0) {
            return (
                <Grid container direction="column" spacing={4} alignItems="center" justifyContent="center">
                    <Grid item>
                        <img
                            style={{ maxWidth: "100%", height: "auto" }}
                            src="https://front-source-assets.s3.sa-east-1.amazonaws.com/emprestimo/VAMOS+DAR+CONTINUIDADE+POR+AQUI.png"
                            alt="Vamos dar continuidade por aqui"
                        />
                    </Grid>
                    <Grid item sx={{ width: "100%" }}>
                        <Button variant="contained" sx={{ width: "100%" }} onClick={() => setManualPhotosStep(1)}>
                            Inserir as fotos
                        </Button>
                    </Grid>
                </Grid>
            )
        }

        const current = contentToRender[manualPhotosStep as number - 1]
        const file = photos[current.key as keyof typeof photos]

        return (
            <Box mt={4} mb={.5} display="flex" flexDirection="column" alignItems="center">
                {!file && <Typography variant="h5" align="center" gutterBottom>
                    {manualPhotosStep as number > 1 ? "Agora, " : ""} {manualPhotosStep as number > 1 ? "clique " : "Clique"} abaixo para tirar a <br /><strong>{current.title}</strong>
                </Typography>}

                {!file && <FormLabel htmlFor={`uploadPhoto-${manualPhotosStep}`} sx={{ mt: !file ? 3 : 0, cursor: "pointer", width: "100%" }}>
                    <Button variant="outlined" component="span" sx={{ width: "100%", textTransform: "uppercase" }}>
                        Tirar {file && "outra"} foto agora
                    </Button>
                </FormLabel>}

                <input
                    id={`uploadPhoto-${manualPhotosStep}`}
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    capture={current.capture as any}
                    style={{ display: "none" }}
                    onChange={(e) => {
                        if (e.target?.files?.[0]) {
                            handleFileChange(current.key, e.target.files[0])
                        }
                    }}
                />

                {file ? (
                    <Paper
                        elevation={3}
                        sx={{
                            mt: 0,
                            p: 2,
                            width: '100%',
                            maxWidth: 400,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2
                        }}
                    >
                        <img
                            src={URL.createObjectURL(file)}
                            alt="Foto"
                            style={{ width: '100%', borderRadius: 8 }}
                        />
                        <Typography variant="body2">{file.name}</Typography>
                    </Paper>
                ) : (
                    <Typography sx={{ mt: 2 }} textAlign={"center"} fontSize={"1rem"} variant="overline">Clique no botão acima para tirar a foto.</Typography>
                )}

                {!!file && <LoadingButton
                    id="button"
                    variant="contained"
                    sx={{ mt: 2, width: "100%" }}
                    onClick={manualPhotosStep as number < contentToRender.length ? handleNextStep : sendPhotos}
                    disabled={!file}
                    loading={loading}
                >
                    CLIQUE PARA ENVIAR A FOTO AGORA
                </LoadingButton>}

                {!!file && <FormLabel htmlFor={`uploadPhoto-${manualPhotosStep}`} sx={{ mt: 2, cursor: "pointer", width: "100%" }}>
                    <Button variant="outlined" component="span" sx={{ width: "100%", textAlign: "center" }} disabled={loading}>
                        ou, se a foto não estiver legal <br /> clique aqui para tirar outra foto
                    </Button>
                </FormLabel>}
            </Box >
        )
    }

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result as string)
            reader.onerror = reject
        })
    }

    useEffect(() => {
        if (!state?.value) navigate(-1)
    }, [])

    useEffect(() => {
        const scroll = async () => {
            const buttonElement = document.getElementById('button')
            if (buttonElement) {
                await Utils.wait(1)
                buttonElement.scrollIntoView({ block: "end", behavior: "smooth" })
            }
        }
        scroll()
    }, [photos])

    useEffect(() => {
        const savedStep = sessionStorage.getItem('manualPhotosStep')

        setTimeout(() => {
            if (savedStep && savedStep !== "null") {
                setManualPhotosStep(Number(savedStep))
            } else {
                setManualPhotosStep(0)
            }
        }, 1000);

        const restorePhotos = async () => {
            const data = await get<{ photos: Record<string, string> }>("manualPhotosData")

            if (data?.photos) {
                try {
                    const entries = await Promise.all(
                        Object.entries(data.photos).map(async ([key, base64]) => {
                            const res = await fetch(base64)
                            const blob = await res.blob()
                            console.log(`Restaurando ${key} - tipo:`, blob.type)
                            const file = new File([blob], `${key}.jpg`, { type: blob.type })
                            return [key, file] as const
                        })
                    )

                    const restored = Object.fromEntries(entries) as typeof photos
                    setPhotos(restored)
                } catch (err) {
                    console.error("Erro ao restaurar fotos do IndexedDB:", err)
                }
            }

            setRestoring(false)
        }

        restorePhotos()
    }, [])


    useEffect(() => {
        if (restoring) return

        sessionStorage.setItem('manualPhotosStep', String(manualPhotosStep))

        const savePhotos = async () => {
            const photoEntries = await Promise.all(
                Object.entries(photos).map(async ([key, file]) => {
                    if (!file) return [key, null]
                    const base64 = await fileToBase64(file)
                    return [key, base64]
                })
            )
            const clean = Object.fromEntries(photoEntries.filter(([, v]) => v))
            set("manualPhotosData", { photos: clean });
        }

        savePhotos()
    }, [manualPhotosStep, photos, restoring])


    return (
        <Grid container justifyContent="center" className="container" id="containerPhotos">
            <Grid item xs={12} sm={10} md={8} lg={6}>
                {manualPhotosStep as number > 0 && (
                    <Box sx={{ width: '100%', mb: 4 }}>
                        <LinearProgress
                            key={"linear-" + manualPhotosStep}
                            variant="buffer"
                            value={(manualPhotosStep as number / totalSteps) * 100}
                            color="primary"
                        />
                        <Typography variant="caption" fontSize={"1.2rem"} display="block" align="right" sx={{ mt: 0.5 }}>
                            {manualPhotosStep} / {totalSteps}
                        </Typography>
                    </Box>
                )}
                {renderStep()}
            </Grid>
        </Grid>
    )
}
